// Plan ID enumeration for billing plans
export default Object.freeze({
	Core: 375,
	Office: 376,
	Essential: 378,
	Ecommerce: 377,
	CoreV380: 380,
	OfficeV381: 381,
	EcommerceV383: 383,
	PAYG: 382,
	Trial: 384,
	// New lineup 2026
	Trial401: 401,
	Basic402: 402,
	Professional403: 403,
	MultiLocation404: 404,
	MultiLocation405: 405,
	MultiLocation406: 406,
	RetentionBasic407: 407,
	RetentionLite408: 408,
});
